export const GDPR_COOKIE_CONSENT_OK_EVENT = 'gdpr-cookie-consent-ok';
